/* eslint-disable vue/no-unused-vars */
<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      <el-breadcrumb-item>订单列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!--搜索栏区域-->
    <el-row :gutter="20" class="search">
      <el-col :span="10">
        <el-input placeholder="请输入查找订单">
          <el-button slot="append" icon="el-icon-search"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <!--订单列表表格部分-->
    <el-table :data="tableData.slice((currentPage-1) * pageSize,currentPage * pageSize)" border stripe style="width: 100%">
      <el-table-column prop="orderNo" label="订单编号" align="center"></el-table-column>
      <el-table-column prop="payment" label="实际付款金额(元)" align="center"></el-table-column>
      <el-table-column prop="discount" label="优惠金额(元)" align="center"></el-table-column>
      <el-table-column prop="createTime" label="下单时间" align="center"></el-table-column>
      <el-table-column prop="status" label="是否发货" align="center">
        <!--订单状态显示,可以通过color指定标签的颜色,后面更改-->
        <template scope="scope">
          <el-button v-if="scope.row.status === 4" type="danger" effect="dark" @click="orderStatusChange" disabled size="medium">已取消</el-button>
          <el-button v-if="scope.row.status === 0" type="warning" effect="dark" @click="orderStatusChange(scope.row)" size="medium">待付款</el-button>
          <el-button v-if="scope.row.status === 1" type="info" effect="dark" @click="orderStatusChange(scope.row)">待发货</el-button>
          <el-button v-if="scope.row.status === 2" type="primary" effect="dark" size="medium" disabled >待收货</el-button>
          <el-button v-if="scope.row.status === 3" type="success" effect="dark" disabled size="medium">交易成功</el-button>
          <el-button v-if="scope.row.status === 4"  effect="dark" disabled size="medium">售后处理</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页器-->
    <el-pagination background
                   layout="prev, pager, next"
                   :total="this.tableData.length"
                   :current-page="currentPage"
                   :page-size="7"
                   style="text-align: center;margin-top: 10px"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentPage" >
    </el-pagination>
  </div>
</template>

<script>
import request from '../../http/order'
export default {
  data () {
    return {
      tableData: [], // 存放表格数据数组
      currentPage: 1, // 初始页
      pageSize: 8 //    每页的数据
    }
  },
  created () {
    this.getTableList() // 创建组件时调用该函数获取表格列表数据
  },
  methods: {
    // pageSize改变时触发
    handleSizeChange (size) {
      this.pagesize = size
      // console.log('handleSizeChange')
    },
    // 当前页面改变时触发
    handleCurrentPage (currentPage) {
      this.currentPage = currentPage
    },
    /* 获取表格列表数据请求 */
    async getTableList () {
      // eslint-disable-next-line no-unused-vars
      // const { data: res } = await this.$http.get('orders', {})
      let isEmpty = false// 是否取完
      let currentPage = 1 // 页码
      while (isEmpty !== 0) { // 取到的数据不为空 循环
        const resData = await request.getOrderTableList({
          current: currentPage++, // 当前页码
          size: 8, // 每页数据
          status: 5 // 设置默认获取所有订单
        })
        // console.log(resData.data)
        if (resData.data.data.length === 0) { // 若取到的数据为空
          isEmpty = true
        } else {
          this.tableData = this.tableData.concat(resData.data.data)
        }
      }
    },
    /* 改变订单状态请求 */
    async  orderStatusChange (row) {
      const id = row.id
      // console.log(id)
      await request.changeOrderStatus(id) // 传给后端id值修改当前订单状态为待收货
      location.reload()// 刷新页面显示最新状态
      // console.log(changeResult)
    }
  }
}
</script>

<style lang="less" scoped>
  .search{
    margin-bottom: 10px;
  }
</style>
